import React, { useState, useEffect } from 'react'

import { BellIcon, BadgeIcon } from '@pb/components'
import { getLabelFromStorage } from '@pb/utils'
import { withRouter } from 'react-router-dom'

import { ACCOUNT_ROUTES } from 'App/constants'

import InboxFlyout from '../InboxFlyout'
import styles from './Inbox.scss'

const Inbox: React.FC<any> = ({
  hasUnreadMessages,
  shouldShowInbox,
  isKlarnaAuthenticated,
  toggleInbox,
  history,
  isOpen,
}) => {
  const defaultLabel = getLabelFromStorage('omni.myaccount.inbox.modal.title').trim()
  // This label ends with space for some reason
  const hasMessagesLabel = `${defaultLabel} - ${getLabelFromStorage(
    'omni.myaccount.inbox.new.invoice.due.soon.heading',
  )}`
  const closeLabel = `${getLabelFromStorage('text.button.close')} ${defaultLabel}`
  const [ariaLabel, setAriaLabel] = useState(defaultLabel)

  useEffect(() => {
    if (hasUnreadMessages) {
      setAriaLabel(hasMessagesLabel)
    }
    if (isOpen) {
      setAriaLabel(closeLabel)
    }
    if (!hasUnreadMessages && !isOpen) {
      setAriaLabel(defaultLabel)
    }
  }, [isOpen, hasUnreadMessages])

  const handleIconClick = (): any => {
    if (isKlarnaAuthenticated) {
      toggleInbox()
    } else {
      history.push(ACCOUNT_ROUTES.HMPay.path)
    }
  }

  if (shouldShowInbox) {
    return (
      <>
        <BadgeIcon
          className={styles.icon}
          hasBadge={hasUnreadMessages}
          icon={<BellIcon />}
          onClick={handleIconClick}
          ariaLabel={ariaLabel}
        />

        <InboxFlyout />
      </>
    )
  }

  return null
}

export default withRouter(Inbox)
